import { CalendarClock, ShieldCheck, WalletCards } from "lucide-react";

export const appUrl = "https://web.subleak.app";

export const renewalRows = [
  { name: "Cloudflare Pro", due: "2 days", group: "Domain / Security", amount: "700 THB" },
  { name: "GitHub Team", due: "5 days", group: "Dev tools", amount: "1,120 THB" },
  { name: "Netflix Premium", due: "7 days", group: "Streaming", amount: "419 THB" },
] as const;

export const features = [
  {
    icon: WalletCards,
    title: "Track real spend",
    copy: "Group costs by currency, provider, account, category, and billing cycle.",
  },
  {
    icon: CalendarClock,
    title: "See renewal pressure",
    copy: "Spot renewals due soon, expired services, and history after each extension.",
  },
  {
    icon: ShieldCheck,
    title: "Ready for web and mobile",
    copy: "Use the same Cloudflare API from the web app now and Flutter later.",
  },
] as const;
